<template>
  <div
    v-if="show"
    id="processing-popup"
  >
    <div class="dot-container">
      <div class="dot1" />
      <div class="dot2" />
      <div class="dot3" />
    </div>
    <div
      v-if="header"
      class="p-header"
    >
      {{ header }}
    </div>
    <div class="p-sub">
      Please do not navigate away from this page or refresh the
      page until the transaction is complete.
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderProcessingOverlay',
  props: {
    show: Boolean,
    header: String,
  },
};
</script>

<style lang="scss">

#processing-popup {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 100;
  .dot-container {
    display: flex;
    margin-bottom: 20px;
    div {
      height: 20px;
      width: 20px;
      border-radius: 50%;
      margin: 0 12px;
      background: #6859a3;
      @media (max-width: 320px) {
        height: 15px;
        width: 15px;
      }
      &.dot1 {
        z-index:1;
        -moz-animation: bounce 1.5s infinite ease-in-out;
        -webkit-animation: bounce 1.5s infinite ease-in-out;
      }
      &.dot2 {
        -moz-animation: bounce 1.5s infinite ease-in-out;
        -webkit-animation: bounce 1.5s infinite ease-in-out;
        -webkit-animation-delay: 0.5s;
        animation-delay: 0.5s;
      }
      &.dot3 {
        -moz-animation: bounce 1.5s infinite ease-in-out;
        -webkit-animation: bounce 1.5s infinite ease-in-out;
        -webkit-animation-delay: 1s;
        animation-delay: 1s;
      }
    }
  }
  .p-header {
    font-size: 2rem;
    color: $WHITE;
    @media (max-width: 320px) {
      font-size: 1.5rem;
    }
  }
  .p-sub {
    font-size: 1.25rem;
    line-height: 1.4;
    text-align: center;
    width: 40%;
    margin-top: 8px;
    color: $WHITE;
    @media (max-width: 430px) {
      width: 80%;
    }
  }
}

@keyframes bounce {
  0%,15% {transform: translate(0,0);}
  50% {transform: translate(0,-40px);background:#72c2c2;}
  85%, 100% {transform: translate(0,0);};
}

@-moz-keyframes bounce {
  0%,15% {-moz-transform: translate(0,0);}
  50% {-moz-transform: translate(0,-40px);background:#72c2c2;}
  85%, 100% {-moz-transform: translate(0,0);};
}

@-webkit-keyframes bounce {
  0%,20% {-webkit-transform: translate(0,0);}
  50% {-webkit-transform: translate(0,-40px);background:#72c2c2;}
  80%, 100% {-webkit-transform: translate(0,0);};
}
</style>
